import { getRequest } from '../common/http/lib';
import { CURRENT_USER_API_URL } from '../constants';
import type { User } from '../types/User';

const getCurrentUser = async (): Promise<User> =>
  getRequest(`${CURRENT_USER_API_URL}`).then(response => response.data);

const UserAPI = {
  getCurrentUser,
} as const;
export default UserAPI;
